import React from "react";
import moment from "moment";
import _ from "lodash";

import { DATE_TIME_FORMAT } from "../../../../constants";
import { getFullName } from "../../../../utils";


const OrderItemTemplate = (props) => {
    const { orderItem, materialDetails, handleProductsDetails, createdUserDetails } = props

    const createdByUser = createdUserDetails.find(eachUser => eachUser.userId === orderItem.createdBy)
    let buyerName = getFullName(createdByUser?.firstName, createdByUser?.lastName)

    const getProducts = (rowData) => {
        let productNamesArr = []
        
        if(rowData.poPunch){
            rowData.poPunch.map(eachPOPunch => {
                if(eachPOPunch.poPunchItems){
                    eachPOPunch.poPunchItems.map(eachPOPunchItem => {
                        if(eachPOPunchItem.buyerReqItemId){
                            const relatedMaterialDetails = materialDetails?.find(obj => obj.buyerReqItemId === eachPOPunchItem.buyerReqItemId)
                            if(relatedMaterialDetails){
                                const productName = relatedMaterialDetails.companyProdName ? relatedMaterialDetails.companyProdName : relatedMaterialDetails.productName
                                productNamesArr.push(productName)
                            }
                        }
                    })
                }
            })
        }

        productNamesArr = _.uniq(productNamesArr)

        return (
            <>
                {/*<Tooltip target={`.custom-tool-tip-${orderItem.consumerOrderId}`} position="top" autoHide className='post-req-tooltip' >
                    <p className='m-0'>{productNamesArr.join(", ")}</p>
                </Tooltip>*/}
                <p className={`custom-tool-tip-${orderItem.consumerOrderId}`} style={{ margin: "0px" }} >
                    {productNamesArr.join(", ")}
                </p>
            </>
        )
    }

    const getProductsCount = (row) => {
        let poPunchItemsCount = 0
        row.poPunch.map(eachPOPunch => {
            if(eachPOPunch.poPunchItems){
                eachPOPunch.poPunchItems.map(eachPOPunchItem => {
                    poPunchItemsCount += 1
                })
            }
        })
        return poPunchItemsCount
    }

    return (
        <div className="flex flex-column purchase-order-template" style={{ width: "100%", marginBottom: "14px" }}>
            <div className="flex flex-column md:flex-row purchase-order-template-header gap-2" >
                <div className="flex flex-row md:flex-column" style={{ flex: "1.3" }}>
                    <span style={{ fontSize: "13px" }}>POSTED ON</span>
                    <span className='md:mt-1 font-bold ml-2 md:ml-0'>{moment(new Date(orderItem.createdAt)).format(DATE_TIME_FORMAT)}</span>
                </div>
                <div className="flex flex-row md:flex-column" style={{ flex: "1.5"}}>
                    <span style={{ fontSize: "13px" }}>POSTED BY</span>
                    <span className='md:mt-1 font-bold ml-2 md:ml-0'>{buyerName}</span>
                </div>
                <div className="flex flex-row md:flex-column flex-1">
                    <span style={{ fontSize: "13px", textAlign: "center" }}>ITEM COUNT</span>
                    <span className='md:mt-1 font-bold ml-2 md:ml-0' style={{textAlign: "center"}}>{getProductsCount(orderItem)}</span>
                </div>
                <div className="flex flex-row md:flex-column" style={{ flex: "3"}}>
                    <span className="product" style={{ fontSize: "13px" }}>PRODUCTS</span>
                    <span className='md:mt-1 mb-2 ml-2 md:ml-0' style={{color: "grey", fontSize: "12px", overflow: "hidden", textOverflow: "ellipsis"}}>{getProducts(orderItem)}</span>
                </div>
                <div className="flex flex-column md:align-items-end" style={{ flex: "2"}}>
                    <span 
                        className='font-bold order-id' 
                        style={{ color: "rgb(18 124 103)", fontSize: "15px" }}
                    >
                        # {orderItem.consumerOrderId}
                    </span>
                    <a className='mt-1' style={{ cursor: "pointer" }} onClick={() => handleProductsDetails(orderItem)} >
                        {orderItem ?
                            <> View Product Details <i className="pi pi-window-maximize" style={{ color: 'grey', fontWeight: "bold", marginTop: "1px" }} ></i> </> 
                            :
                            ""
                        }
                    </a>
                </div>
            </div>
            <div className="flex purchase-order-template-footer">
            </div>
        </div>
    )
}

export default OrderItemTemplate;